import { useCallback, useEffect, useMemo, useState } from 'react'
import { TRANSFER_EVENT_COMPLETE, TRANSFER_EVENT_INIT } from '../transfer-types/upload-base'
import { isTransferFinished } from '../transfer-status'

export const useTransferData = transfer => {
  const [state, updateState] = useState({})

  const getData = useCallback(transfer => {
    if (!transfer) {
      return {}
    }

    return {
      id: transfer.id,
      type: transfer.type,
      name: transfer.name,
      filename: transfer.filename,
      size: transfer.size,
      queued: transfer.queued,
      status: transfer.status,
      gotoPath: transfer.gotoPath,
      progress: transfer.progress,
      msgData: transfer.msgData,
      isStatusInit: transfer.status === TRANSFER_EVENT_INIT
    }
  }, [])

  useEffect(
    () => {
      let state = getData(transfer)
      updateState(state)

      const handleEvent = () => {
        let state = getData(transfer)
        updateState(state)
      }

      transfer && transfer.addEventListener(handleEvent)

      return () => {
        transfer && transfer.removeEventListener(handleEvent)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [transfer]
  )

  return state
}

// A page's own transfer (the copy pages): running from the moment it is
// made until it finishes -- complete, failed or canceled -- so a failed copy
// gives its form back to try again.
export const useTransferActive = transfer => {
  const transferData = useTransferData(transfer)

  return useMemo(
    () => {
      if (!transferData.id) {
        return false
      }

      return !isTransferFinished(transferData)
    },
    [transferData]
  )
}

export const useTransferComplete = (transfer, onComplete) => {
  const transferData = useTransferData(transfer)

  useEffect(
    () => {
      if (transferData.status === TRANSFER_EVENT_COMPLETE) {
        return onComplete && onComplete()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [transferData]
  )
}

export const useTransferNodeCopyAllowGoto = (transfer, organizationID) => {
  const transferData = useTransferData(transfer)

  const allowGoto = useMemo(() => transferData.msgData && transferData.msgData.organizationID === organizationID, [transferData, organizationID])

  return allowGoto
}
